import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import HelpTooltip from '../../../../components/tooltip/HelpTooltip'
import CurrencyInput from '../../../../components/form/CurrencyInput'
import AmountWarn from '../../AmountWarn'
import { setDailyBudget } from '../adGroupSlice'
import PropTypes from 'prop-types'
import { integerValue } from '../../../../utils'

const AdGroupDailyBudget = ({ error }) => {
  const dispatch = useDispatch()
  const { dailyBudget, beforeDailyBudget } = useSelector(
    state => state.ad.adGroup.form
  )
  const handleChange = useCallback(
    value => {
      dispatch(setDailyBudget(integerValue(value)))
    },
    [dispatch]
  )
  return (
    <div className={classNames('area_item', { error })}>
      <strong className="subtit_box">
        일예산
        <HelpTooltip>
          하루 기준의 통합 지출 한도를 의미하며, 일 예산을 초과할 경우 광고
          집행이 중지됩니다.
        </HelpTooltip>
      </strong>
      <div className="cont_card">
        <div className="item_card">
          <div className="group_item">
            <CurrencyInput
              name="dailyBudget"
              min={1000}
              max={10000000}
              step={10}
              maxLength={8}
              value={dailyBudget}
              error={error}
              onValueChange={handleChange}
            />
            <AmountWarn
              before={beforeDailyBudget}
              after={dailyBudget}
              error={error}
            />
          </div>
          {error ? (
            <p className="txt_error">{error}</p>
          ) : (
            <p className="desc_item">
              광고그룹 일예산은 최소 1,000원 ~ 최대 1천만원까지 10원 단위로
              설정할 수 있습니다.
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
AdGroupDailyBudget.propTypes = {
  error: PropTypes.string,
}
export default AdGroupDailyBudget
